<template>
  <div class="article-container">
    <h1 class="article-title">
      {{ article[id].title }}
    </h1>
    <span class="article-time">最后更新时间：{{ article[id].time }}</span>
    <div class="acticle-body"
         v-if="id === 0"
         v-html="article[id].body">
      <!-- {{ article[id].body }} -->
    </div>
    <div class="acticle-body"
         v-if="id === 10">
      <guide-article />
    </div>
  </div>
</template>

<script>
import GuideArticle from './GuideArticle.vue';
export default {
  data() {
    return {
      title: null,
      time: null,
      id: null,
      body: null,
      article: {
        0: {
          title: '美团地图开放平台上线',
          time: '2021年8月17日',
          body: `      <span
        >美团开放平台于近期上线了Web API服务，包括搜索，路线规划，地理编码，位置描述，行政区域查询，地图匹配6个服务13个接口，详细信息请参考技术支持文档。
      </span><span>我们会在未来继续深化服务与应用，为您提供高效，稳定的服务。 </span>
      <span
        >如果您在使用过程中遇到任何问题，请与我们联系，也期待您为我们提出宝贵的意见和建议。
      </span>`
        },
        10: {
          title: '美团地图开发者合规指南',
          time: '2021年8月17日',
          body: ''
        }
      }
    };
  },
  components: { GuideArticle },
  created() {
    this.id = this.$route.query.id;
  }
};
</script>

<style scoped lang="less">
.article-container {
  /* padding: auto; */
  width: 876px;

  .article-title {
    margin-top: 12px;
    font-family: PingFangSC-Medium;
    font-size: 36px;
    color: rgba(0, 0, 0, 0.84);
    font-weight: 500;
    line-height: 50px;
  }
  .article-time {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 24px;
    font-weight: 400;
  }
  .acticle-body {
    padding: 0;
    margin-top: 48px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.72);
    // text-align: justify;
    line-height: 24px;
    font-weight: 400;
    white-space: pre-wrap;
  }
}
</style>
